import { createSlice } from "@reduxjs/toolkit";
import { createCustomAsyncThunk } from './utils';
import { lessonMaterialService } from "../services/lessonService";
import { initialValues } from "../constants";
import { useDispatch, useSelector } from 'react-redux';
import React from "react";

export const getLessonMaterial = createCustomAsyncThunk(
    "lessonMaterial/get",
    async id => await lessonMaterialService.get(id)
)

export const createLessonMaterial = createCustomAsyncThunk(
    "lessonMaterial/create",
    async data => await lessonMaterialService.post(data)
)

export const updateLessonMaterial = createCustomAsyncThunk(
    "lessonMaterial/update",
    async data => await lessonMaterialService.patch(data)
)

export const addFileToLessonMaterial = createCustomAsyncThunk(
    "lessonMaterial/addFile",
    async data => await lessonMaterialService.addFile(data)
)

const lessonMaterialSlice = createSlice({
    name: "lessonMaterial",
    initialState: {
        data: initialValues.lessonMaterial,
        isLoading: false,
        error: null
    },
    reducers: {
        resetLessonMaterial: state => { state.data = null }
    },
    extraReducers: builder => {
        builder
            .addCase(getLessonMaterial.pending, state => { state.isLoading = true })
            .addCase(getLessonMaterial.fulfilled, (state, action) => {
                state.data = action.payload.length > 0 ? action.payload[0] : initialValues.lessonMaterial
                state.isLoading = false
            })
            .addCase(getLessonMaterial.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(createLessonMaterial.pending, state => { state.isLoading = true })
            .addCase(createLessonMaterial.fulfilled, (state, action) => {
                state.data = action.payload
                state.isLoading = false
            })
            .addCase(createLessonMaterial.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(updateLessonMaterial.pending, state => { state.isLoading = true })
            .addCase(updateLessonMaterial.fulfilled, (state, action) => {
                state.data = action.payload
                state.isLoading = false
            })
            .addCase(updateLessonMaterial.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(addFileToLessonMaterial.pending, state => { state.isLoading = true })
            .addCase(addFileToLessonMaterial.fulfilled, (state, action) => {
                state.data = action.payload
                state.isLoading = false
            })
            .addCase(addFileToLessonMaterial.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })
    }
})

export default lessonMaterialSlice.reducer

export const useLessonMaterial = lesson => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        if (lesson?.id) { dispatch(getLessonMaterial(lesson.id)) }
    }, [dispatch, lesson])

    const { data, isLoading } = useSelector(x => x.lessonMaterial)

    return { lessonMaterial: data, lessonMaterialIsLoading: isLoading }
}